module.exports = __webpack_public_path__ + "media/images/webpage/logo/icot-logo-white-cbabce3c99800111e8eaee0f5b6e40a5.svg";